import classNames from 'classnames';
import React, { memo } from 'react';
import './event.component.scss';

export declare namespace EventType {
  type Props = {
    className?: string | null;
    children?: React.ReactNode | null;
    variant?: 'click' | 'hover';
    stopPropagation?: boolean;
    onClick?: () => void;
    disabled?: boolean;
  };
}

export const Event = memo(
  ({
    children,
    className,
    variant = 'click',
    stopPropagation = true,
    onClick,
    disabled = false,
  }: EventType.Props) => {
    return (
      <div
        className={classNames(
          'event',
          {
            'event--disabled': disabled,
            'event--clickable': variant === 'click' && !disabled,
            'event--hoverable': variant === 'hover' && !disabled,
          },
          className,
        )}
        onClick={(e) => {
          if (disabled) return;
          e.preventDefault();
          if (stopPropagation) {
            e.stopPropagation();
          }
          onClick?.();
        }}
      >
        {children}
      </div>
    );
  },
);
